import { useEffect } from 'react'

import { LanguageUtils } from '@space-shell/common/utils/language'
import i18n from '@space-shell/config/i18n'

type UseLanguageSetupParams = {
  language: string
}

export const useLanguageSetup = ({ language }: UseLanguageSetupParams) => {
  useEffect(() => {
    const normalizedLocale = LanguageUtils.normalizeLocale(language)
    LanguageUtils.setLanguage(normalizedLocale, i18n)
  }, [language])
}
